import { faqService } from '../../services'
import { faqConstants } from '../constants'
import { request, success, failure } from './helper'

function getFaqs(query = '') {
  return async dispatch => {
    dispatch(request(faqConstants.REQUEST))
    try {
      const payload = await faqService.getFaqs(query)
      return dispatch(success(faqConstants.SUCCESS, { payload }))
    } catch (error) {
      return dispatch(failure(faqConstants.FAILURE, error))
    }
  }
}

function getRelatedFaq(query) {
  return async dispatch => {
    dispatch(request(faqConstants.REQUEST))
    try {
      const payload = await faqService.getRelatedFaq(query)
      return dispatch(success(faqConstants.SUCCESS_RELATED, { payload }))
    } catch (error) {
      return dispatch(failure(faqConstants.FAILURE, error))
    }
  }
}

function getRefinedFaqs(query = '', type) {
  return async dispatch => {
    dispatch(request(faqConstants.REFINED_REQUEST))

    if (type === 'tagCloud') {
      try {
        const payload = await faqService.getFaqsWithTagCloud(query)
        return dispatch(success(faqConstants.REFINED_SUCCESS, { payload }))
      } catch (error) {
        return dispatch(failure(faqConstants.REFINED_FAILURE, error))
      }
    } else if (type === 'search') {
      try {
        const payload = await faqService.getFaqs(query)
        return dispatch(success(faqConstants.REFINED_SUCCESS, { payload }))
      } catch (error) {
        return dispatch(failure(faqConstants.REFINED_FAILURE, error))
      }
    }
  }
}

function saveFaqLog(payload) {
  return async dispatch => {
    dispatch(request(faqConstants.SAVE_FAQ_LOG_REQUEST))
    try {
      const response = await faqService.saveFaqLog(payload)
      return dispatch(success(faqConstants.SAVE_FAQ_LOG_SUCCESS, response))
    } catch (error) {
      return dispatch(failure(faqConstants.SAVE_FAQ_LOG_FAILURE, error))
    }
  }
}

function setFaqScore(payload) {
  return async dispatch => {
    dispatch(request(faqConstants.SET_FAQ_SCORE_REQUEST))
    try {
      const response = await faqService.postFaqScore(payload)
      return dispatch(success(faqConstants.SET_FAQ_SCORE_SUCCESS, response))
    } catch (error) {
      return dispatch(failure(faqConstants.SET_FAQ_SCORE_FAILURE, error))
    }
  }
}

function setActiveFaq(index) {
  return dispatch => dispatch(request(faqConstants.SET_ACTIVE, { index }))
}

function getFaqsCategories() {
  return async dispatch => {
    dispatch(request(faqConstants.CATEGORY_REQUEST))
    try {
      const payload = await faqService.getFaqsCategories()
      return dispatch(success(faqConstants.CATEGORY_SUCCESS, { payload }))
    } catch (error) {
      return dispatch(failure(faqConstants.CATEGORY_FAILURE, error))
    }
  }
}

function getFaqTagCloud() {
  return async dispatch => {
    dispatch(request(faqConstants.TAG_CLOUD_REQUEST))
    try {
      const payload = await faqService.getFaqTagCloud()
      return dispatch(success(faqConstants.TAG_CLOUD_SUCCESS, { payload }))
    } catch (error) {
      return dispatch(failure(faqConstants.TAG_CLOUD_FAILURE, error))
    }
  }
}

function saveUserFaqHistory(payload) {
  return async dispatch => {
    try {
      const { id } = payload
      if (!id) throw new Error()

      const faq_path_v1 = JSON.stringify({ id })
      faqService.saveUserFaqHistory(faq_path_v1)

      return dispatch(success(faqConstants.SAVE_FAQ_USER_HISTORY_SUCCESS, { id }))
    } catch (err) {
      return dispatch(failure(faqConstants.SAVE_FAQ_USER_HISTORY_FAILURE, err))
    }
  }
}

function saveFaqVoteModalFeedback(payload) {
  return async dispatch => {
    dispatch(request(faqConstants.SAVE_FAQ_SCORE_FEEDBACK_REQUEST))
    try {
      await faqService.saveFaqScoreFeedback(payload)
      return dispatch(success(faqConstants.SAVE_FAQ_SCORE_FEEDBACK_SUCCESS))
    } catch (error) {
      return dispatch(failure(faqConstants.SAVE_FAQ_SCORE_FEEDBACK_FAILURE, error))
    }
  }
}

export default {
  getFaqs,
  getRefinedFaqs,
  getRelatedFaq,
  setActiveFaq,
  setFaqScore,
  getFaqsCategories,
  getFaqTagCloud,
  saveUserFaqHistory,
  saveFaqVoteModalFeedback,
  saveFaqLog,
}
